import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import httpClient from 'agentHTTPClient';

import { Link } from '@wtag/react-comp-lib';
import Icon from '@wtag/rcl-icon';
import IconButton from '@wtag/rcl-icon-button';
import Card from '@wtag/rcl-card';
import CommentPlaceholder from '../../../Placeholder/CommentPlaceholder';
import HotelLoyaltyProgramForm from './HotelLoyaltyProgramForm';

const HotelLoyaltyProgramCard = props => {
  const {
    personId,
    fetchHotelLoyaltyPrograms,
    hotelLoyaltyList,
    hotelLoyaltyProgram,
    hotelRoutes,
  } = props;

  const [editing, setEditing] = useState(false);
  const [error, setError] = useState({});
  const [number, setNumber] = useState('');
  const [program, setProgram] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const updateHotelLoyaltyProgram = async Id => {
    const hotelLoyaltyProgramParams = {
      hotel_guest_number: number,
      hotel_guest_program: program,
      person_id: personId,
    };

    const { data } = await httpClient.patch(hotelRoutes.update({ personId, id: Id }), {
      hotel_loyalty_program: hotelLoyaltyProgramParams,
    });

    if (data.error === null) {
      fetchHotelLoyaltyPrograms();
      setEditing(false);
    }
  };

  const onUpdateHotelLoyaltyProgram = Id => {
    setIsLoading(true);
    updateHotelLoyaltyProgram(Id)
      .catch(({ response }) => {
        if (response.status === 422) {
          setError(response.data.error);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const deleteHotelLoyaltyProgram = async Id => {
    setIsLoading(true);
    const { data } = await httpClient.delete(hotelRoutes.delete({ personId, id: Id }));

    if (data.error === null) {
      fetchHotelLoyaltyPrograms();
      setEditing(false);
      setIsLoading(false);
    }
  };

  const onDeleteHotelLoyaltyProgram = Id =>
    deleteHotelLoyaltyProgram(Id).catch(({ response }) => {
      if (response.status === 422) {
        setError(response.data.error);
      }
    });

  useEffect(() => {
    setNumber(hotelLoyaltyProgram.number);
    setProgram(hotelLoyaltyProgram.program);
  }, [hotelLoyaltyProgram]);

  const renderLoaders = component => {
    if (isLoading) {
      return (
        <CommentPlaceholder
          numberOfCards={1}
          numberOfRows={1}
          removeContentPadding={true}
          removeBoxShadow={true}
        />
      );
    }
    return (
      <Card
        className="traveller-edit-loyalty-program__container"
        key={hotelLoyaltyProgram.id}
        version="v2"
      >
        {component}
      </Card>
    );
  };

  return (
    <Fragment>
      {editing
        ? renderLoaders(
            <Fragment>
              <div className="col-grid col-bleed direction-row align-center justify-space-between traveller-edit-loyalty-program-section__update">
                <span className="traveller-edit-loyalty-program-section__update--header">
                  {I18n.t(
                    'admin.components.travellers.edit.loyalty_programs.hotel_loyalty.update.header',
                  )}
                </span>
                <span className="traveller-edit-loyalty-program__actions">
                  <IconButton
                    className="traveller-edit-loyalty-program__actions--check"
                    icon={<Icon name="check" />}
                    color="tertiary"
                    size="small"
                    onClick={() => onUpdateHotelLoyaltyProgram(hotelLoyaltyProgram.id)}
                  />
                  <IconButton
                    icon={<Icon name="close" />}
                    color="tertiary"
                    size="small"
                    onClick={() => setEditing(false)}
                  />
                </span>
              </div>
              <div className="col-12 col-bleed traveller-edit-loyalty-program-section__update">
                <div className="grid">
                  <div className="col-lg-12">
                    <HotelLoyaltyProgramForm
                      hotelLoyaltyList={hotelLoyaltyList}
                      setNumber={setNumber}
                      number={number}
                      setProgram={setProgram}
                      program={program}
                      hotelError={error}
                    />
                  </div>
                </div>
              </div>
            </Fragment>,
          )
        : renderLoaders(
            <Fragment>
              <div className="col-grid col-bleed direction-row traveller-edit-loyalty-program">
                <div className="traveller-edit-loyalty-program__summary">
                  <span className="traveller-edit-loyalty-program__content--disabled">
                    {I18n.t(hotelLoyaltyProgram.program, {
                      scope:
                        'simple_form.options.person.hotel_loyalty_programs.hotel_guest_program',
                    })}
                  </span>
                  <span className="traveller-edit-loyalty-program__content">
                    {hotelLoyaltyProgram.number}
                  </span>
                </div>
                <div className="traveller-edit-loyalty-program__actions">
                  <span className="traveller-edit-loyalty-program__content">
                    <Link
                      type="icon-button"
                      modifier="tertiary"
                      onClick={() => onDeleteHotelLoyaltyProgram(hotelLoyaltyProgram.id)}
                    >
                      <Icon name="delete" size="small" />
                    </Link>
                  </span>
                  <span className="traveller-edit-loyalty-program__content">
                    <Link
                      className="traveller-edit-loyalty-program__content--link"
                      labelHint={I18n.t('admin.shared.action.edit')}
                      type="icon-button"
                      modifier="tertiary"
                      onClick={() => setEditing(true)}
                    >
                      <Icon name="edit" size="small" />
                    </Link>
                  </span>
                </div>
              </div>
            </Fragment>,
          )}
    </Fragment>
  );
};

HotelLoyaltyProgramCard.defaultProps = {
  hotelLoyaltyProgram: {},
};

HotelLoyaltyProgramCard.propTypes = {
  personId: PropTypes.number.isRequired,
  fetchHotelLoyaltyPrograms: PropTypes.func.isRequired,
  hotelLoyaltyList: PropTypes.arrayOf(PropTypes.shape([])).isRequired,
  hotelLoyaltyProgram: PropTypes.shape({
    id: PropTypes.number,
    number: PropTypes.string,
    program: PropTypes.string,
  }),
  hotelRoutes: PropTypes.shape({
    update: PropTypes.func.isRequired,
    delete: PropTypes.func.isRequired,
  }).isRequired,
};

export default HotelLoyaltyProgramCard;
